export default {
  VERY_FAST: '0.3s',
  FAST: '0.5s',
  NORMAL: '0.7s',
  SLOW: '0.9s',
  VERY_SLOW: '1.1s',
}
